import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import {
  MatAutocompleteModule,
  MatBadgeModule,
  MatBottomSheetModule,
  MatButtonModule,
  MatChipsModule,
  MatFormFieldModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatRippleModule,
  MatTooltipModule,
} from "@angular/material";
import { CustomTranslatePipeModule } from "../../../pipes/customTranslate/customTranslate.pipe.module";
import { BrandImgPipeModule } from "../../../pipes/brand-img-pipe/brand-img.module";

import { CpsAutocompleteComponent } from "./cps-autocomplete.component";
import { CpsMultipleSelectorComponent } from "./cps-multiple-selector/cps-multiple-selector.component";

@NgModule({
  declarations: [CpsAutocompleteComponent, CpsMultipleSelectorComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatTooltipModule,
    MatChipsModule,
    MatRippleModule,
    CustomTranslatePipeModule,
    MatListModule,
    MatInputModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    FormsModule,
    MatIconModule,
    TranslateModule,
    BrandImgPipeModule,
  ],
  exports: [CpsAutocompleteComponent],
  entryComponents: [CpsMultipleSelectorComponent],
})
export class CpsAutocompleteModule {}
